import { Card } from "components/ui/card";
import React from "react";

const ShimmerLoader: React.FC = () => {
  return (
    <Card className="p-4  animate-pulse">
      {/* User Info Skeleton */}
      <div className="flex items-center space-x-3">
        <div className="bg-gray-300 dark:bg-gray-600 h-10 w-10 rounded-full"></div>
        <div className="flex-1">
          <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-1/3"></div>
          <div className="h-3 bg-gray-200 dark:bg-gray-500 rounded w-1/4 mt-2"></div>
        </div>
      </div>

      {/* Post Content Skeleton */}
      <div className="mt-4 space-y-3">
        <div className="h-4 bg-gray-300 dark:bg-gray-600 rounded w-full"></div>
        <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-5/6"></div>
        <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-4/6"></div>
      </div>

      {/* Post Image Skeleton */}
      <div className="mt-3 h-40 bg-gray-300 dark:bg-gray-600 rounded-lg"></div>

      {/* Post Actions Skeleton */}
      <div className="mt-3 flex space-x-4">
        <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-16"></div>
        <div className="h-4 bg-gray-200 dark:bg-gray-500 rounded w-16"></div>
      </div>
    </Card>
  );
};

export default ShimmerLoader;

